import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';
import CustomModal from './CustomModal';

var DUMMY_SUBS = [
  {company:'AUTODEX',plan:'Pro',startDate:'2026-01-15',endDate:'2027-01-15',status:'active',ocrCount:245,storage:'1.8GB'},
  {company:'한국수출물류(주)',plan:'Basic',startDate:'2026-02-10',endDate:'2027-02-10',status:'active',ocrCount:87,storage:'0.5GB'},
  {company:'글로벌카 트레이딩',plan:'Trial',startDate:'2026-03-20',endDate:'2026-04-20',status:'trial',ocrCount:12,storage:'0.1GB'}
];

function AdminLogs(props) {
  var [modal, setModal] = useState(null);
  var closeModal = function() { setModal(null); };
  var tab = props.tab;
  var sysLogs = props.sysLogs;
  var sysStats = props.sysStats;
  var logFilter = props.logFilter;
  var setLogFilter = props.setLogFilter;
  var expandedLog = props.expandedLog;
  var setExpandedLog = props.setExpandedLog;
  var activityLogs = props.activityLogs;
  var ocrStats = props.ocrStats;
  var fetchLogs = props.fetchLogs;
  var showToast = props.showToast;

  var th = props.th;
  var td = props.td;
  var badge = props.badge;
  var btnStyle = props.btnStyle;

  if (tab === 'email') {
    return (<div>
      <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:700,color:'#0f172a'}}>이메일/SMTP 설정</h3>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))',gap:16}}>
        {[
          {company:'AUTODEX',host:'smtp.gmail.com',port:465,email:'kyeongilpark3@gmail.com',status:'connected'},
          {company:'한국수출물류(주)',host:'',port:0,email:'',status:'none'},
          {company:'글로벌카 트레이딩',host:'smtp.naver.com',port:465,email:'globalcar@naver.com',status:'connected'}
        ].map(function(e,i){return(
          <div key={i} style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,padding:20}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
              <div style={{fontWeight:700,fontSize:14,color:'#0f172a'}}>{e.company}</div>
              {badge(e.status,e.status==='connected'?'연결됨':'미설정')}
            </div>
            {e.host?<>
              <div style={{fontSize:12,color:'#64748b',marginBottom:4}}>SMTP: {e.host}:{e.port}</div>
              <div style={{fontSize:12,color:'#64748b',marginBottom:12}}>Email: {e.email}</div>
            </>:<div style={{fontSize:12,color:'#94a3b8',marginBottom:12}}>SMTP 설정이 없습니다</div>}
            <div style={{display:'flex',gap:8}}>
              <button style={{flex:1,padding:'6px',border:'1px solid #93c5fd',borderRadius:6,fontSize:12,cursor:'pointer',background:'#fff',color:'#2563eb',fontWeight:600}}>테스트 발송</button>
              <button style={{flex:1,padding:'6px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,cursor:'pointer',background:'#fff',fontWeight:600}}>설정 수정</button>
            </div>
          </div>
        )})}
      </div>
    </div>);
  }

  if (tab === 'logs') {
    if(!sysLogs.length&&!sysStats.totalErrors)fetchLogs();
    var typeBadge=function(t){var m={'ERROR':{bg:'#fef2f2',c:'#991b1b'},'UNCAUGHT':{bg:'#fef2f2',c:'#7f1d1d'},'UNHANDLED_REJECTION':{bg:'#fffbeb',c:'#92400e'}};var s=m[t]||{bg:'#f0f2f5',c:'#475569'};return <span style={{background:s.bg,color:s.c,padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:600}}>{t}</span>};
    return(<div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:10,marginBottom:14}}>
        <div style={{background:'#fff',borderRadius:8,padding:'14px 16px',border:'1px solid #e5e7eb'}}><div style={{fontSize:11,color:'#94a3b8'}}>전체 에러</div><div style={{fontSize:22,fontWeight:600,color:'#dc2626'}}>{sysStats.totalErrors}</div></div>
        <div style={{background:'#fff',borderRadius:8,padding:'14px 16px',border:'1px solid #e5e7eb'}}><div style={{fontSize:11,color:'#94a3b8'}}>API 에러</div><div style={{fontSize:22,fontWeight:600,color:'#ea580c'}}>{sysStats.apiErrors}</div></div>
        <div style={{background:'#fff',borderRadius:8,padding:'14px 16px',border:'1px solid #e5e7eb'}}><div style={{fontSize:11,color:'#94a3b8'}}>Uncaught Exception</div><div style={{fontSize:22,fontWeight:600,color:'#dc2626'}}>{sysStats.uncaughtExceptions}</div></div>
        <div style={{background:'#fff',borderRadius:8,padding:'14px 16px',border:'1px solid #e5e7eb'}}><div style={{fontSize:11,color:'#94a3b8'}}>Unhandled Rejection</div><div style={{fontSize:22,fontWeight:600,color:'#ca8a04'}}>{sysStats.unhandledRejections}</div></div>
        <div style={{background:'#fff',borderRadius:8,padding:'14px 16px',border:'1px solid #e5e7eb'}}><div style={{fontSize:11,color:'#94a3b8'}}>오늘 OCR 사용</div><div style={{fontSize:22,fontWeight:600,color:'#2563eb'}}>{ocrStats.todayCount}회</div></div>
        <div style={{background:'#fff',borderRadius:8,padding:'14px 16px',border:'1px solid #e5e7eb'}}><div style={{fontSize:11,color:'#94a3b8'}}>이번달 OCR</div><div style={{fontSize:22,fontWeight:600,color:'#1B3A5C'}}>{ocrStats.monthCount}회</div></div>
      </div>
      {ocrStats.byType.length>0&&<div style={{marginBottom:14}}>
        <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
          {ocrStats.byType.map(function(t,i){return(<span key={i} style={{padding:'3px 10px',borderRadius:6,fontSize:10,fontWeight:600,background:'#eff6ff',color:'#1e40af'}}>{t.detail} {t.cnt}회</span>)})}
        </div>
      </div>}
      <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:12}}>
        <select value={logFilter} onChange={function(e){setLogFilter(e.target.value)}} style={{padding:'6px 10px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12}}>
          <option value="all">전체</option><option value="ERROR">ERROR</option><option value="UNCAUGHT">UNCAUGHT</option><option value="UNHANDLED_REJECTION">UNHANDLED_REJECTION</option>
        </select>
        <button onClick={fetchLogs} style={{padding:'6px 14px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>조회</button>
        <button onClick={function(){setModal({type:'danger',title:'로그를 모두 초기화할까요?',message:'',confirmText:'초기화',onConfirm:function(){closeModal();authFetch(API+'/admin/logs',{method:'DELETE'}).then(function(){fetchLogs();showToast&&showToast('로그 초기화 완료','success')})}})}} style={{padding:'6px 14px',background:'#fff',color:'#dc2626',border:'1px solid #fca5a5',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer',marginLeft:'auto'}}>로그 초기화</button>
      </div>
      {sysLogs.length===0&&<div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>기록된 에러 로그가 없습니다</div>}
      {sysLogs.length>0&&<div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'auto',maxHeight:'calc(100vh - 360px)'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead><tr>
            {['No','시간','타입','메시지'].map(function(h){return <th key={h} style={{padding:'8px 10px',fontWeight:600,color:'#475569',fontSize:12,background:'#f0f2f5',textAlign:'left'}}>{h}</th>})}
          </tr></thead>
          <tbody>
            {sysLogs.map(function(l,i){return(<React.Fragment key={l.id}>
              <tr style={{background:i%2===0?'#fff':'#f8f9fb',cursor:'pointer'}} onClick={function(){setExpandedLog(expandedLog===l.id?null:l.id)}}>
                <td style={{padding:'7px 10px',fontSize:11,color:'#94a3b8',textAlign:'center',width:40}}>{l.id}</td>
                <td style={{padding:'7px 10px',fontSize:11,color:'#64748b',whiteSpace:'nowrap',width:160}}>{(l.timestamp||'').slice(0,19)}</td>
                <td style={{padding:'7px 10px',width:140}}>{typeBadge(l.type)}</td>
                <td style={{padding:'7px 10px',fontSize:12,maxWidth:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:expandedLog===l.id?'normal':'nowrap'}}>{l.message}</td>
              </tr>
            </React.Fragment>)})}
          </tbody>
        </table>
      </div>}

      <div style={{marginTop:24}}>
        <h4 style={{fontSize:14,fontWeight:600,color:'#1B3A5C',marginBottom:10}}>사용자 활동 로그</h4>
        {activityLogs.length===0&&<div style={{textAlign:'center',padding:30,color:'#94a3b8',fontSize:13}}>활동 로그 없음</div>}
        {activityLogs.length>0&&<div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'auto',maxHeight:300}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead><tr>
              {['No','시간','사용자','액션','상세','IP'].map(function(h){return <th key={h} style={{padding:'8px 10px',fontWeight:600,color:'#475569',fontSize:12,background:'#f0f2f5',textAlign:'left'}}>{h}</th>})}
            </tr></thead>
            <tbody>
              {activityLogs.map(function(l,i){
                var ab=l.action==='login'?{bg:'#dcfce7',c:'#166534',label:'로그인'}:l.action==='login_fail'?{bg:'#fef2f2',c:'#991b1b',label:'로그인 실패'}:l.action==='ocr_use'?{bg:'#eff6ff',c:'#1e40af',label:'OCR 사용'}:{bg:'#f0f2f5',c:'#475569',label:l.action};
                return(<tr key={l.id} style={{background:i%2===0?'#fff':'#f8f9fb'}}>
                  <td style={{padding:'7px 10px',fontSize:11,color:'#94a3b8',textAlign:'center',width:40}}>{i+1}</td>
                  <td style={{padding:'7px 10px',fontSize:11,color:'#64748b',whiteSpace:'nowrap'}}>{(l.createdAt||'').slice(0,19)}</td>
                  <td style={{padding:'7px 10px',fontWeight:600,fontSize:12}}>{l.userId||'-'}{l.userName?' ('+l.userName+')':''}</td>
                  <td style={{padding:'7px 10px'}}><span style={{background:ab.bg,color:ab.c,padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:600}}>{ab.label}</span></td>
                  <td style={{padding:'7px 10px',fontSize:12}}>{l.detail}</td>
                  <td style={{padding:'7px 10px',fontSize:11,color:'#94a3b8',fontFamily:'monospace'}}>{l.ip}</td>
                </tr>);
              })}
            </tbody>
          </table>
        </div>}
      </div>
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
    </div>);
  }

  if (tab === 'billing') {
    return (<div>
      <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:700,color:'#0f172a'}}>결제/구독 관리</h3>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:16,marginBottom:20}}>
        {[{plan:'Basic',count:1,color:'#64748b'},{plan:'Pro',count:1,color:'#2563eb'},{plan:'Enterprise',count:0,color:'#7c3aed'}].map(function(p){return(
          <div key={p.plan} style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,padding:20,textAlign:'center'}}>
            <div style={{fontSize:13,color:'#94a3b8',marginBottom:4}}>{p.plan}</div>
            <div style={{fontSize:32,fontWeight:800,color:p.color}}>{p.count}</div>
            <div style={{fontSize:12,color:'#94a3b8'}}>업체</div>
          </div>
        )})}
      </div>
      <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'hidden'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead><tr>
            {['업체명','플랜','시작일','만료일','상태','이번달 OCR','스토리지'].map(function(h){return <th key={h} style={th}>{h}</th>})}
          </tr></thead>
          <tbody>
            {DUMMY_SUBS.map(function(s,i){return(
              <tr key={i} style={{background:i%2===1?'#fafafa':'#fff'}}>
                <td style={{...td,fontWeight:600}}>{s.company}</td>
                <td style={td}>{badge(s.plan==='Trial'?'trial':'active',s.plan)}</td>
                <td style={{...td,fontSize:12}}>{s.startDate}</td>
                <td style={{...td,fontSize:12}}>{s.endDate}</td>
                <td style={td}>{badge(s.status,s.status==='active'?'활성':'체험')}</td>
                <td style={{...td,textAlign:'center',fontWeight:700,color:'#1B3A5C'}}>{s.ocrCount}회</td>
                <td style={{...td,textAlign:'center',fontSize:12}}>{s.storage}</td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
    </div>);
  }

  return null;
}

export default AdminLogs;
